import { useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';

import { useHttpClient } from '@bonusly/http-client';

const pageSize = 3;

// We use an ID for each instance of the hook. Otherwise every set of responses will be
// linked to every comment.
export const useSuggestedResponses = (bonusId: string) => {
	const [index, setIndex] = useState(0);
	const http = useHttpClient();

	const {
		data = [],
		isFetched,
		isFetching,
		isLoading,
	} = useQuery({
		queryKey: ['suggested-responses', bonusId],
		queryFn: async () => {
			const res = await http.get<{ result: string[] }>('/suggestions', {
				params: { bonus_id: bonusId },
			});

			return res.data.result;
		},
	});

	const regenerate = useCallback(() => {
		if (data.length && data.length > index + pageSize) {
			setIndex(index + pageSize);
		} else {
			setIndex(0);
		}
	}, [data, index]);

	return {
		isFetched: isFetched,
		isGenerating: !isLoading && isFetching,
		isLoading: isLoading,
		suggestions: data.slice(index, index + pageSize),
		regenerate,
	};
};
